var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.757 6.343a1 1 0 10-1.414 1.414L10.586 12l-4.243 4.243a1 1 0 001.414 1.414L12 13.414l4.243 4.243a1 1 0 001.414-1.414L13.414 12l4.243-4.243a1 1 0 10-1.414-1.414L12 10.586 7.757 6.343z",
    fill: "#fff"
  })));
}

export default SvgClose;